import React, { useCallback } from "react";
import { MenuItem, OutlinedTextFieldProps, TextField } from "@material-ui/core";
import { SelectorProps } from ".";
import { Controller, ControllerProps, useFormContext } from "react-hook-form";

interface TextProps extends OutlinedTextFieldProps {
  "data-testid"?: string;
}
export interface DropdownProps {
  fieldProps?: Partial<TextProps>;
  controllerProps?: Partial<ControllerProps<typeof TextField>>;
  allowEmpty?: boolean;
}

export const DropdownSelector: React.FC<SelectorProps & DropdownProps> = ({
  name,
  options,
  onChange,
  allowEmpty,
  controllerProps,
  fieldProps,
}) => {
  const handleChange = useCallback(
    ([event]) => {
      const v = String(event.target.value);
      if (onChange) {
        onChange(v);
      }
      return v;
    },
    [onChange],
  );
  const { control } = useFormContext(); // Must provide a FormContext wrapper for this component

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={
        controllerProps?.defaultValue ?? (allowEmpty ? "" : options[0]!.value)
      }
      onChange={handleChange}
      rules={{ required: fieldProps?.required }}
      as={
        <TextField
          select
          size="small"
          required
          variant="outlined"
          {...fieldProps}
        >
          {allowEmpty && (
            <MenuItem value="">
              <em>Select</em>
            </MenuItem>
          )}
          {options.map((opt) => (
            <MenuItem value={opt.value} key={`opt-${opt.value}`}>
              {opt.name}
            </MenuItem>
          ))}
        </TextField>
      }
    />
  );
};
